import React, { useState } from "react";
import data from "../data.json";

const inputStyle = {
  width: "100%",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid var(--border)",
  borderRadius: "var(--radius-sm)",
  padding: "12px 15px",
  color: "#fff",
  fontSize: 14,
  fontFamily: "var(--font)",
  outline: "none",
  marginBottom: 14,
  transition: "border-color var(--ease)",
};

export default function Contact() {
  const { company } = data;
  const [form, setForm] = useState({
    name: "",
    email: "",
    service: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const infoItems = [
    { icon: "📧", label: "Email", value: company.email },
    { icon: "📞", label: "Phone", value: company.phone },
    { icon: "📍", label: "Location", value: `${company.location} 🌸` },
  ];

  const socials = [
    { icon: "📸", label: "Instagram", href: company.socials.instagram },
    { icon: "💼", label: "LinkedIn", href: company.socials.linkedin },
    { icon: "🐦", label: "Twitter", href: company.socials.twitter },
    { icon: "▶️", label: "YouTube", href: company.socials.youtube },
  ];

  return (
    <section
      id="contact"
      style={{ padding: "110px 0", position: "relative", overflow: "hidden" }}
    >
      {/* Bg glow */}
      <div
        style={{
          position: "absolute",
          width: 450,
          height: 450,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(255,107,43,0.06), transparent 70%)",
          bottom: "-8%",
          left: "-4%",
          pointerEvents: "none",
        }}
      />

      <div className="container">
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 60 }}>
          <div className="section-label center">Let's Talk</div>
          <h2 className="section-title">Ready to Scale?</h2>
          <p
            className="section-sub"
            style={{ margin: "0 auto", maxWidth: 500 }}
          >
            Tell us about your brand and we'll craft a custom growth strategy
            built for real results.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1.7fr",
            gap: 48,
            alignItems: "start",
          }}
          className="contact-grid"
        >
          {/* Left info */}
          <div>
            <h3
              style={{
                fontSize: "1.38rem",
                fontWeight: 900,
                color: "#fff",
                marginBottom: 9,
                letterSpacing: "-0.02em",
              }}
            >
              Get in Touch
            </h3>
            <p
              style={{
                color: "var(--gray-400)",
                fontSize: 14,
                lineHeight: 1.8,
                marginBottom: 24,
              }}
            >
              From Park Street to your industry — we're ready to get to work.
            </p>

            {infoItems.map((item, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: 13,
                  alignItems: "center",
                  padding: 16,
                  borderRadius: "var(--radius-sm)",
                  background: "var(--bg-card)",
                  border: "1px solid var(--border)",
                  marginBottom: 12,
                  transition: "border-color var(--ease)",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = "rgba(255,107,43,0.3)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor = "var(--border)")
                }
              >
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    flexShrink: 0,
                    background: "rgba(255,107,43,0.12)",
                    border: "1px solid rgba(255,107,43,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 16,
                  }}
                >
                  {item.icon}
                </div>
                <div>
                  <div
                    style={{
                      fontSize: 10,
                      color: "var(--gray-500)",
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      marginBottom: 1,
                    }}
                  >
                    {item.label}
                  </div>
                  <div style={{ color: "#fff", fontSize: 13, fontWeight: 600 }}>
                    {item.value}
                  </div>
                </div>
              </div>
            ))}

            <div style={{ display: "flex", gap: 9, marginTop: 14 }}>
              {socials.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  title={s.label}
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                    background: "var(--bg-card)",
                    border: "1px solid var(--border)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 16,
                    transition: "all var(--ease)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255,107,43,0.15)";
                    e.currentTarget.style.borderColor = "rgba(255,107,43,0.4)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "var(--bg-card)";
                    e.currentTarget.style.borderColor = "var(--border)";
                    e.currentTarget.style.transform = "none";
                  }}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Form */}
          <div
            style={{
              background: "var(--bg-card)",
              borderRadius: "var(--radius)",
              padding: 38,
              border: "1px solid var(--border)",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Top line */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: 2,
                background:
                  "linear-gradient(90deg, var(--accent), var(--accent3), var(--accent2))",
              }}
            />

            {submitted ? (
              <div style={{ textAlign: "center", padding: "36px 0" }}>
                <div style={{ fontSize: 58, marginBottom: 16 }}>🎉</div>
                <h3
                  style={{
                    fontSize: "1.45rem",
                    fontWeight: 900,
                    color: "#fff",
                    marginBottom: 10,
                  }}
                >
                  Message Received!
                </h3>
                <p
                  style={{
                    color: "var(--gray-400)",
                    lineHeight: 1.78,
                    fontSize: 14,
                    maxWidth: 330,
                    margin: "0 auto",
                  }}
                >
                  Thank you for reaching out. Our Kolkata team will get back to
                  you within 24 hours. 🌸
                </p>
                <button
                  onClick={() => {
                    setSubmitted(false);
                    setForm({ name: "", email: "", service: "", message: "" });
                  }}
                  className="btn-primary"
                  style={{ marginTop: 22 }}
                >
                  Send Another →
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 14,
                  }}
                  className="form-2col"
                >
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: 10.5,
                        color: "var(--gray-400)",
                        marginBottom: 6,
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: 1,
                      }}
                    >
                      Your Name
                    </label>
                    <input
                      name="name"
                      type="text"
                      value={form.name}
                      onChange={handleChange}
                      required
                      placeholder="Arjun Chatterjee"
                      style={inputStyle}
                      onFocus={(e) =>
                        (e.target.style.borderColor = "rgba(255,107,43,0.5)")
                      }
                      onBlur={(e) =>
                        (e.target.style.borderColor = "var(--border)")
                      }
                    />
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        fontSize: 10.5,
                        color: "var(--gray-400)",
                        marginBottom: 6,
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: 1,
                      }}
                    >
                      Email Address
                    </label>
                    <input
                      name="email"
                      type="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      placeholder="contact@vylinx.com"
                      style={inputStyle}
                      onFocus={(e) =>
                        (e.target.style.borderColor = "rgba(255,107,43,0.5)")
                      }
                      onBlur={(e) =>
                        (e.target.style.borderColor = "var(--border)")
                      }
                    />
                  </div>
                </div>

                <label
                  style={{
                    display: "block",
                    fontSize: 10.5,
                    color: "var(--gray-400)",
                    marginBottom: 6,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  Service Interested In
                </label>
                <select
                  name="service"
                  value={form.service}
                  onChange={handleChange}
                  required
                  style={{
                    ...inputStyle,
                    appearance: "none",
                    cursor: "pointer",
                  }}
                  onFocus={(e) =>
                    (e.target.style.borderColor = "rgba(255,107,43,0.5)")
                  }
                  onBlur={(e) => (e.target.style.borderColor = "var(--border)")}
                >
                  <option value="" disabled>
                    Select a service...
                  </option>
                  {data.services.map((s) => (
                    <option
                      key={s.id}
                      value={s.title}
                      style={{ background: "#0A0A1C" }}
                    >
                      {s.title}
                    </option>
                  ))}
                </select>

                <label
                  style={{
                    display: "block",
                    fontSize: 10.5,
                    color: "var(--gray-400)",
                    marginBottom: 6,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  Your Message
                </label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  placeholder="Tell us about your business, goals and challenges..."
                  style={{ ...inputStyle, resize: "vertical", minHeight: 110 }}
                  onFocus={(e) =>
                    (e.target.style.borderColor = "rgba(255,107,43,0.5)")
                  }
                  onBlur={(e) => (e.target.style.borderColor = "var(--border)")}
                />

                <button
                  type="submit"
                  className="btn-primary"
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    fontSize: 14,
                    padding: 14,
                  }}
                >
                  Send Message →
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .contact-grid { grid-template-columns: 1fr !important; }
          .form-2col { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
